<template>
    <div id="app">
        <router-view />
    </div>
</template>
<script>
    export default {
        name: 'App'
    }
</script>
<style>
    html,
    body,
    #app {
        height: 100%;
    }

    #app {
        min-width: 800px;
        width: 100%;
        font-family: "Helvetica Neue", Helvetica, "PingFang SC", "Hiragino Sans GB", "Microsoft YaHei", "微软雅黑", Arial, sans-serif;
    }

    .options:hover {
        background: #007acc;
        cursor: pointer;
        border-radius: 8px;
    }

    .options {
        margin: 5px 20px;
        padding: 10px;
    }

    .fontSizeMax {
        font-size: 24;
    }

    .fontSizeMid {
        font-size: 18;
    }

    .fontSizeMin {
        font-size: 12;
    }
</style>


// WEBPACK FOOTER //
// src/App.vue